import { StateUpdaterMap } from "src/model/manager/state-manager";
import { AppState } from "..";

export interface ProvidersActions {
    GROOWTHBOOK_ERROR_SET: {error: any} 
    GROOWTHBOOK_INIT: {}

}

export const providersActions : StateUpdaterMap<AppState, ProvidersActions> = {
    GROOWTHBOOK_ERROR_SET: (error, {providers}) => ({
        providers : {
            ...providers,
            growthbook: {
                error: error,
                hasError: !!error,
                isInit: false
            }
        }
    }),
    GROOWTHBOOK_INIT: (_, {providers}) => ({
        providers : {
            ...providers,
            growthbook: {
                error: null,
                hasError: false,
                isInit: true
            }
        }
    }),
};